import { render, staticRenderFns } from "./GreenOperationActionBtns.vue?vue&type=template&id=36fb8af1&scoped=true&"
import script from "./GreenOperationActionBtns.vue?vue&type=script&lang=js&"
export * from "./GreenOperationActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationActionBtns.vue?vue&type=style&index=0&id=36fb8af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb8af1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fb8af1')) {
      api.createRecord('36fb8af1', component.options)
    } else {
      api.reload('36fb8af1', component.options)
    }
    module.hot.accept("./GreenOperationActionBtns.vue?vue&type=template&id=36fb8af1&scoped=true&", function () {
      api.rerender('36fb8af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/GreenOperationActionBtns.vue"
export default component.exports